import { LoginActions } from './LoginActions';
import { loginDefaultState, FlowSteps } from './LoginConstants';

const loginReducer = (state, action) => {
  let employeeLoginState = state.employeeLoginState || loginDefaultState;

  switch (action.type) {
    case LoginActions.EMPLOYEES_LOADED: {
      employeeLoginState.employees = action.employees;
      employeeLoginState.processing = false;
      break;
    }

    case LoginActions.BRANCHES_LOADED: {
      employeeLoginState.branches = action.branches;
      employeeLoginState.processing = false;
      break;
    }

    case LoginActions.EMPLOYEE_SELECTED: {
      employeeLoginState.selectedEmployee = action.selectedEmployee;
      break;
    }

    case LoginActions.EMPLOYEE_UPDATE_SUCCESSFUL: {
      employeeLoginState.selectedEmployee = action.selectedEmployee;
      employeeLoginState.processing = false;
      break;
    }

    case LoginActions.EMPLOYEE_UPDATE_ERROR: {
      employeeLoginState.employeeErrors = action.errors;
      employeeLoginState.processing = false;
      break;
    }

    case LoginActions.EMPLOYEES_CONFLICTS_LOADED: {
      employeeLoginState.employeeConflicts = action.result || [];
      employeeLoginState.processing = false;
      break;
    }

    case LoginActions.EMPLOYEE_LOGGED_IN: {
      employeeLoginState.processing = false;
      employeeLoginState.loginComplete = true;
      if(Object.prototype.hasOwnProperty.call(state, 'user')) {
        state.user = {
          ...state.user,
          assignment: {
            employee: action.employee,
            branch: action.branch
          }
        };
      }
      break;
    }

    case LoginActions.EMPLOYEE_LOGIN_FAILED: {
      employeeLoginState.processing = false;
      employeeLoginState.flowSteps = {
        ...employeeLoginState.flowSteps,
        [`${FlowSteps.LOGGED_IN}`]: false,
      };
      break;
    }

    case LoginActions.EMPLOYEE_SEARCH_STARTED:
    case LoginActions.BRANCH_SEARCH_STARTED:
    case LoginActions.EMPLOYEE_UPDATE_STARTED:
    case LoginActions.EMPLOYEE_LOGIN_STARTED: {
      employeeLoginState.processing = true;
      break;
    }

    case LoginActions.LOGIN_FLOW_CHANGED: {
      if (action.shouldReset) {
        employeeLoginState.employees = [];
        employeeLoginState.employeeConflicts = [];
        employeeLoginState.branches = [];
        employeeLoginState.flowSteps = {
          ...employeeLoginState.flowSteps,
          [`${FlowSteps.PROFILE_SELECTED}`]: false,
          [`${FlowSteps.BRANCH_SELECTED}`]: false,
          [`${FlowSteps.LOGGED_IN}`]: false,
        };
      } else {
        if (action.stepToAdd) {
          employeeLoginState.flowSteps = {
            ...employeeLoginState.flowSteps,
            [`${action.stepToAdd}`]: true,
          };
        }
        if (action.stepToRemove) {
          employeeLoginState.flowSteps = {
            ...employeeLoginState.flowSteps,
            [`${action.stepToRemove}`]: false,
          };
        }
      }
      break;
    }

    case LoginActions.LOGIN_FLOW_ENABLED: {
      employeeLoginState.loginFlowEnabled = true;
      break;
    }

    case LoginActions.EMPLOYEE_SEARCH_FAILED:
    case LoginActions.BRANCH_SEARCH_FAILED:
    case LoginActions.EMPLOYEE_UPDATE_FAILED: {
      employeeLoginState.processing = false;
      break;
    }

    case LoginActions.LOGGED_OUT: {
      employeeLoginState.processing = false;
      employeeLoginState.hasLoggedOut = true;
      break;
    }

    default:
      return state;
  }

  return {
    ...state,
    employeeLoginState,
  };
};

export default loginReducer;
